<template>
          <!-- <v-snackbar
              :color="color"
              :top="top"
              :right="right"
              v-model="snackbar"
              dark
            >
              <v-icon
                color="white"
                class="mr-3"
              >
                mdi-bell-plus
              </v-icon>
              <div>
                {{this.mensagem}}
              </div>
              <v-icon
                size="16"
                @click="snackbar = false"
              >
                mdi-close-circle
              </v-icon>
            </v-snackbar> -->
  <v-dialog v-model="dialogMsg" max-width="550px" max-height="300px" persistent> 
      <v-card style="border-radius: 12px;" elevation="0">
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
              <!-- <span class="subtotal" v-if="loading">{{msgLoading}}</span> -->
              <span class="total" :style="`color:${this.color};`">{{this.titulo}}</span>              
              </v-card-title>
              <!-- <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                    class="resumo"
                  > -->
              <v-card-text>
                <p class="subtotal" style="text-align: center; text-size: 12px">{{this.mensagem}}</p>
              </v-card-text>
             <!--  </v-container> -->
            </v-layout>            
          </v-container>
          <v-card-actions>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >
              <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" dark @click="close()">Fechar</v-btn>
              </v-container>
            </v-card-actions>
      </v-card>
    </v-dialog>       
</template>

<script>
export default {
    data () {
    return {
    color: '',
    mensagem: '',
    titulo: '',
    top: true,
    right: false,
    snackbar: false,
    dialogMsg: false
    }

    },
    methods: {

      snackOld(cor, msg) {
      this.top = true
      this.right = true
      this.color = cor
      this.mensagem = msg
      this.snackbar = true
      },
      close(){
        this.dialogMsg = false
      },
      snack(cor,msg,tit){
        this.titulo = tit
        this.color = cor
        this.mensagem = msg
        this.dialogMsg = true 
      }
    }
}
</script>

<style>

</style>
